import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import moment from "moment";
// Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import { translateLauguage } from "../Function/Translate";
import { AuthContext } from "../Context/AuthContext";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import FooterPagination from "../Components/Include/FooterPagination";
import { GET_STUDENT_WITH_PAGINATION } from "../Schema/Student";
import ViewImage from "../Components/Student/ViewImage";

export default function Students() {
  // Change Language
  const { language } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const handleToDetails = (id) => {
    navigate(`/students/student-detail?studentId=${id}`);
  };
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  let pageStudent = window.localStorage.getItem("pageStudent");
  const { refetch } = useQuery(GET_STUDENT_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
    },
    onCompleted: ({ getStudentsWithPagination }) => {
      setTableData(getStudentsWithPagination?.data);
      setPaginationData(getStudentsWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, open, keyword]);

  useEffect(() => {
    if (pageStudent) {
      setPage(parseInt(pageStudent));
    } else {
      setPage(1);
    }
  }, [pageStudent]);

  const ClickStudent = (Id) => {
    window.localStorage.setItem("ClickStudentId", Id);
  };

  const StudentSelectId = window.localStorage.getItem("ClickStudentId");

  let pageClickStudentId = window.localStorage.getItem("pageClickStudentId");
  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">Student</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className="search-head-title">Search</Typography>
            <TextField
              placeholder="Search"
              size="small"
              className="search-field"
              onChange={(e) => handleSearch(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ mr: 1 }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell className="header-title-start">N°</TableCell>
                <TableCell className="header-title">Student ID</TableCell>
                <TableCell className="header-title">Full Name</TableCell>
                <TableCell className="header-title">English Name</TableCell>
                <TableCell className="header-title" align="center">
                  Gender
                </TableCell>
                <TableCell className="header-title" align="center">
                  Age
                </TableCell>
                <TableCell className="header-title">Date Of Birth</TableCell>
                <TableCell className="header-title">Address</TableCell>
                <TableCell className="header-title-end"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody
                    className="body"
                    // className={
                    //   window.localStorage.getItem(
                    //     "clickedStudentId"
                    //   ) === data?._id
                    //     ? "body body-active"
                    //     : "body"
                    // }
                    //   onClick={() => {
                    //     window.localStorage.setItem(
                    //       "clickedStudentId",
                    //       data?._id
                    //     )
                    //   }}
                  >
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className={
                            StudentSelectId === row._id
                              ? "body-row onclick-student"
                              : "body-row"
                          }
                          key={index}
                          onClick={() => {
                            ClickStudent(row._id);
                          }}
                        >
                          <TableCell
                            className="body-cell-start"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {index + paginationData?.slNo}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {row?.student_id}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            <ViewImage
                              id={row?._id}
                              stuName={row?.lastName + " " + row?.firstName}
                              profileImg={row?.profileImg}
                            />
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {row?.englishName}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            align="center"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {row?.gender}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            align="center"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {moment().diff(moment(row?.dob), "years")}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {moment(row?.dob).format("DD-MMM-YYYY")}
                          </TableCell>
                          <TableCell
                            className="body-cell"
                            onClick={() => handleToDetails(row?._id)}
                          >
                            {row?.village ? row?.village + "," : ""}
                            {row?.commune ? row?.commune + "," : ""}
                            {row?.district ? row?.district + ", " : ""}
                            {row?.province ? row?.province : ""}
                          </TableCell>
                          <TableCell className="body-cell-end"></TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
          Type="student"
        />
      </Box>
    </div>
  );
}
